import * as R from "ramda";
import React, { useEffect } from "react";
import { Button, Icon, Modal } from "antd";
import Swiper from "react-swipeable-views";

export const ResourceCarousel = (props) => {
  const current = R.pathOr(-1, ["current"], props);
  const dataSource = R.pathOr([], ["dataSource"], props);
  const itemRender = R.pathOr(() => {}, ["itemRender"], props);
  const onChange = R.pathOr(() => {}, ["onChange"], props);
  const enableMouseEvents = R.pathOr(false, ["enableMouseEvents"], props);
  const theme = R.pathOr("light", ["theme"], props);

  useEffect(() => {
    if (current === -1) {
      return;
    }
    //  left, right
    const keydown = (e) => {
      if (e.keyCode === 37) {
        // left
        onChange(Math.max(0, current - 1));
      } else if (e.keyCode === 39) {
        // right
        onChange(Math.min(dataSource.length - 1, current + 1));
      }
    };

    if (enableMouseEvents) {
      document.addEventListener("keydown", keydown);
      return () => {
        document.removeEventListener("keydown", keydown);
      };
    }
  }, [props, current]);

  const visible = current > -1;
  const isDarkTheme = theme === "dark";

  return (
    <Modal
      visible={visible}
      title={null}
      footer={null}
      onCancel={() => onChange(-1)}
      closeIcon={
        isDarkTheme ? (
          <Icon type="close" style={{ color: "white", fontSize: 24 }} />
        ) : undefined
      }
      width="100vw"
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        background: "rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(10px)",
      }}
      bodyStyle={{
        padding: 0,
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <Swiper
          index={current}
          enableMouseEvents
          onChangeIndex={onChange}
          disableLazyLoading={false}
          style={{ width: "100vw", height: "100vh" }}
        >
          {dataSource.map((item, index) => {
            const isActiveLeft = current === index - 1;
            const isActiveRight = current === index + 1;
            //  这样做是为了让当前的和左右两个都显示, 不会出现空白, 如果不这样做, 会在关闭的时候出现看到其他的
            const shouldRender =
              current === index || isActiveLeft || isActiveRight;
            if(!shouldRender) {
              return null;
            }
            return (
              <div
                key={index}
                style={{
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: isDarkTheme ? "black" : "white",
                }}
              >
                {itemRender(item, index)}
              </div>
            );
          })}
        </Swiper>
        <Button
          type="primary"
          size="large"
          shape="round"
          onClick={() => onChange(current - 1)}
          disabled={current === 0}
          style={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            padding: "0 10px",
          }}
          icon="left"
        />

        <Button
          type="primary"
          size="large"
          shape="round"
          onClick={() => onChange(current + 1)}
          disabled={current === dataSource.length - 1}
          style={{
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            padding: "0 10px",
          }}
          icon="right"
        />
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/resource-carousel.js